import isDev from './is-dev'
import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'

Vue.use(isDev)

library.add(
  require('@fortawesome/free-solid-svg-icons/faCode').faCode,
)
